import DividerComponent from './Divider';
import FormButtonComponent from './FormButton';
import SpinnerComponent from './Spinner';

export const Divider = DividerComponent;
export const FormButton = FormButtonComponent;
export const Spinner = SpinnerComponent;
